import { SubmissionError } from 'redux-form';
import { REQUIRED_FIELDS } from './constants';

export const transformToValidationErrors = errors => {
	return Object.entries(errors).reduce((prev, [key, error]) => {
		if (key.includes('tariffs') && key !== 'tariffs') {
			const arr = key.split('.');

			if (!prev.tariffs) {
				prev.tariffs = {};
			}

			prev.tariffs = {
				...prev.tariffs,
				[arr[1]]: {
					...(prev.tariffs[arr[1]] || {}),
					[arr[2]]: error[0],
				},
			};
		}

		prev[key] = error[0];

		return prev;
	}, {});
};

export const validate = values => {
	REQUIRED_FIELDS.forEach(key => {
		if (!values?.[key]) {
			throw new SubmissionError({ [key]: 'Заполните это поле' });
		}
	});
};
